import { render } from "./NotificariBell.vue?vue&type=template&id=9c54d01c&scoped=true&ts=true"
import script from "./NotificariBell.vue?vue&type=script&lang=ts"
export * from "./NotificariBell.vue?vue&type=script&lang=ts"

import "./NotificariBell.vue?vue&type=style&index=0&id=9c54d01c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c54d01c"]])

export default __exports__